/*global trackLogin, trackEvent*/
(function(module) {
    'use strict';
    
    /**
     * This function submit the form data to the trackEvent google/coremetrics function.
     * 
     * @param name      - name to track against.
     * @param event     - event name to track.
     * @param content   - content of the form which to submit.
     */
    var _formSubmit = function(name, event, content) {
        if (typeof trackEvent !== 'undefined') {
            trackEvent(name, event, content);
        }
    };
    
    /**
     * This function sends the email address of a user to the google anayltics/coremetrics
     * trackLogin function which uses ajax to record the email address.
     * 
     * @param name  - name of the tracking event.
     * @param email - email address to record. 
     */
    var _snipeEmail = function(name, email) {
        if (typeof trackLogin !== 'undefined') {
            trackLogin(name, email);
        }
    };
    
    /**
     * This function takes an array, filters out undefined or empty values from the array,
     * then unkebab cases every string in the array, then joins the array together using a 
     * specified delimiter.
     * 
     * @param list      - list to concatenate.
     * @param separator - delimiter to use to separate the list.
     */
    var _arrayConcat = function(list, separator) {
        var filteredList = list.filter(function(val) {
            return val && val.length > 0;
        });
        
        var unkebabed = filteredList.map(function(str) {
            return str.replace('-', ' ');
        });
        
        return unkebabed.join(separator);
    };
    
    module.constant('TRACKING_CONSTANTS', {
        blur: 'blur',
        submit: 'submit',
        submitForm: 'Submit Form',
        googleSeparator: ' - ',
        arrayType: 'array'
    });
    
    module.service('TrackingService', function() {
        return {
            formSubmit: _formSubmit,
            snipeEmail: _snipeEmail,
            arrayConcat: _arrayConcat
        };
    });
    
    module.directive('snipeEmail', ['TRACKING_CONSTANTS', 'TrackingService', function (TRACKING_CONSTANTS, TrackingService) {
        return {
            link: function($scope, $element, $attrs) {
                $element.on(TRACKING_CONSTANTS.blur, function() {
                    TrackingService.snipeEmail($attrs.snipeEmail, $element.val());
                });
            }
        };
    }]);
    
    module.directive('trackFormEvent', ['TRACKING_CONSTANTS', 'TrackingService', function(TRACKING_CONSTANTS, TrackingService) {
        return {
            scope: {
                trackFormEvent: '@',
                content: '@',
                contentAs: '@'
            },
            link: function($scope, $element) {
                $element.on(TRACKING_CONSTANTS.submit, function() {
                    var content = $scope.content;
                        
                    if ($scope.contentAs && $scope.contentAs === TRACKING_CONSTANTS.arrayType) {
                        content = TrackingService.arrayConcat(JSON.parse($scope.content), TRACKING_CONSTANTS.googleSeparator);
                    }
                    
                    TrackingService.formSubmit($scope.trackFormEvent, TRACKING_CONSTANTS.submitForm, content);
                });
            }
        };
    }]);
    
})(angular.module('vholsTracking', []));